module.exports = __webpack_public_path__ + "static/media/layout-four-2.34c6010a.jpg";